import React, { useState, useEffect } from 'react';
import {
  Badge,
  Button,
  ButtonGroup,
  Checkbox,
  Col,
  FlexboxGrid,
  IconButton,
  Panel,
  Stack,
  Tooltip,
  Whisper
} from 'rsuite';
import globalIP from '@/GlobelIP';
import { Link } from 'react-router-dom';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';
import EditIcon from '@rsuite/icons/Edit';
import StackItem from 'rsuite/esm/Stack/StackItem';
import ugr from '@/UGRoute';

const ProductCard = ({
  item,
  label,
  dataGrid = 6,
  selectallvar = () => {},
  openVardata = () => {},
  handleCheckboxChange = () => {},
  selectedItems = [],
  handleOpen = () => {},
  productUpdate = false,
  pid = () => {},
  showCheckbox = null, // null means no preference
  showEditIcon = null, // null means no preference
  showVariant = null, // null means no preference
  showQuickView = null, // null means no preference
  isMoving = false,
  page = ''
}) => {
  const [clicked, setClicked] = useState(false);
  const [hovered, setHovered] = useState(false);
  const multipleImages = item?.attributes?.MultipleImage?.data || [];
  // Sort images alphabetically by file name
  const sortedImages = [...multipleImages].sort((a, b) => {
    const nameA = a?.attributes?.name?.toLowerCase() || '';
    const nameB = b?.attributes?.name?.toLowerCase() || '';
    return nameA.localeCompare(nameB);
  });
  const firstHoverImage = sortedImages[0];
  const [costingData, setCostingData] = useState([]);
  useEffect(() => {
    fetchDatat();
  }, []);
  const fetchDatat = async () => {
    const response = await fetch(`${globalIP}/api/costings?populate=*`);
    const json = await response.json();
    setCostingData(json.data);
  };
  const id = localStorage.getItem('id');
  const [user, setUser] = useState<any>([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/user-details/${id}`);
      const json = await response.json();
      const extractedData = json.data.attributes;
      setUser(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  return (
    <>
      <FlexboxGrid.Item as={Col} key={item.id} colspan={24} md={dataGrid} className="data-tbl-img">
        <Panel
          className="box"
          bordered
          bodyFill
          style={{ display: 'inline-block', width: '100%', height: '296px' }}
        >
          <Stack justifyContent="space-between">
            {showEditIcon === 1 && productUpdate && (
              <Stack className="overlay2">
                <Whisper
                  placement="bottomEnd"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={<Tooltip>Update</Tooltip>}
                >
                  <IconButton icon={<EditIcon />} active size="sm" onClick={pid} />
                </Whisper>
              </Stack>
            )}
            {showEditIcon == 0 && showCheckbox == 0 && (
              <p style={{ color: 'white', opacity: 0 }}>{'erpdaddy'}</p>
            )}
            {showCheckbox === 1 && !productUpdate && (
              <Checkbox
                value={item.id}
                checked={selectedItems.includes(item.id)}
                onChange={(value, checked) => handleCheckboxChange(value, checked)}
              />
            )}

            {item.attributes.Variant &&
              (showVariant === 1 ? (
                <>
                  <ButtonGroup>
                    <IconButton
                      icon={clicked ? <CloseIcon /> : <CheckIcon />}
                      appearance="default"
                      onClick={() => {
                        setClicked(!clicked);
                        selectallvar(item.attributes.ProductCode);
                      }}
                      active
                    />
                    <Button
                      onClick={() => openVardata(item.attributes.ProductCode)}
                      appearance="ghost"
                      color="cyan"
                    >
                      Variant
                    </Button>
                  </ButtonGroup>
                </>
              ) : showVariant === 0 ? (
                <StackItem
                  className="badge"
                  style={{
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    width: '100%'
                  }}
                >
                  <Whisper
                    placement="bottomEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Variant</Tooltip>}
                  >
                    <Badge
                      color="cyan"
                      content="Variant"
                      style={{
                        margin: 4
                      }}
                    />
                  </Whisper>
                </StackItem>
              ) : (
                <></>
              ))}

            {isMoving && selectedItems.includes(item.id) && (
              <StackItem
                className="badge"
                style={{
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  width: '100%'
                }}
              >
                <p
                  style={{
                    marginRight: '10px',
                    backgroundColor: 'rgb(128 215 130)',
                    borderRadius: '11px',
                    padding: '3px'
                  }}
                >
                  Moving
                </p>
              </StackItem>
            )}
          </Stack>
          <div
            className="image-containerm"
            onClick={() => handleCheckboxChange(item.id, !selectedItems.includes(item.id))}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <img
              src={
                hovered && firstHoverImage
                  ? `${globalIP}${firstHoverImage.attributes.url}`
                  : `${globalIP}${item.attributes?.CoverImage?.data?.attributes?.url}`
              }
              alt="Product"
              className="image-style"
            />
          </div>
          {showQuickView === 1 &&
            (dataGrid === 4 || dataGrid === 6 || dataGrid === 8 || dataGrid === 12) && (
              <div className="overlay1">
                <Button
                  style={{ background: 'rgba(0, 0, 0, -0.5)', color: 'white' }}
                  onClick={() => handleOpen('lg', item.id)}
                >
                  Quick View
                </Button>
                <Link
                  to={{
                    pathname: `/${ugr}/productView`,
                    search: `?id=${item.id}&variantId=${item.attributes.Variant_Id}&val=${
                      page === 'variant' ? 0 : 1
                    }`
                  }}
                  className="link"
                  target="_blank"
                >
                  <Button style={{ background: 'rgba(0, 0, 0, -0.5)', color: 'white' }}>
                    Product Details
                  </Button>
                </Link>
              </div>
            )}

          {showQuickView === 0 && (
            <Link
              to={{
                pathname: `/${ugr}/productView`,
                search: `?id=${item.id}&variantId=${item.attributes.Variant_Id}&val=${
                  page === 'variant' ? 0 : 1
                }`
              }}
              className="link"
              target="_blank"
            >
              <div className="overlay">Product Details</div>
            </Link>
          )}
          {showQuickView === 2 && (
            <div className="overlay1">
              <Button
                style={{
                  background: 'rgba(0, 0, 0, -0.5)',
                  color: 'white',
                  textAlign: 'center',
                  width: '-webkit-fill-available '
                }}
                onClick={() => handleOpen('lg', item.id)}
              >
                Quick View
              </Button>
            </div>
          )}
          <Panel>
            <b>Product : {item.attributes.ProductName}</b>
            <p>
              {label[0]?.attributes.AliasCode} : {item.attributes.ProductId}
            </p>

            {user.PRDCostShow === true &&
              (() => {
                const matchedCost = costingData.find(
                  cost => cost?.attributes?.ProductId == item.id
                );
                const totalInr = matchedCost?.attributes?.totalinr;
                return <p>Cost: {totalInr !== undefined ? `${totalInr}` : 'N/A'}</p>;
              })()}
          </Panel>
        </Panel>
      </FlexboxGrid.Item>
    </>
  );
};

export default ProductCard;
